import { jsx as t } from "react/jsx-runtime";
function i(o) {
  return /* @__PURE__ */ t("svg", { fill: "none", height: "16", viewBox: "0 0 11 16", width: "16", xmlns: "http://www.w3.org/2000/svg", ...o, children: /* @__PURE__ */ t(
    "path",
    {
      d: "M4.7625 8.91667H1.1875L8.3375 1.125L6.55 7.08333H10.125L2.975 14.875L4.7625 8.91667Z",
      stroke: "#052643",
      strokeLinejoin: "round",
      strokeWidth: "1.03125"
    }
  ) });
}
export {
  i as default
};
